/** Which firm the source-data panel looks up, as far as the page knows so far. */
export type SourceDataFirm =
  | { kind: "pending" }
  | { kind: "none" }
  | { kind: "known"; companyUuid: string };

export type IndividualFirmInput = {
  /** The page's own firm for the lawyer — `companyIdForCommentary`. */
  companyId: string | null;
  /** The editorial detail read has returned (with or without an entry). */
  detailSettled: boolean;
  /** The address-book firm lookup is running and has not settled. */
  firmLookupPending: boolean;
};

export function individualSourceDataFirm(input: IndividualFirmInput): SourceDataFirm {
  if (input.companyId) return { kind: "known", companyUuid: input.companyId };
  if (!input.detailSettled || input.firmLookupPending) return { kind: "pending" };
  return { kind: "none" };
}
